var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "rgba(0, 0, 0, 0.05)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07615 9.91601C6.82415 8.03201 9.38015 7.61201 9.38015 6.44801C9.38015 5.716 8.80415 5.30801 7.85615 5.30801C7.12415 5.30801 6.52415 5.64401 5.93615 6.25601L4.95215 5.35601C5.72015 4.46801 6.77615 3.88 8.06015 3.88C9.80015 3.88 11.0721 4.69601 11.0721 6.29201C11.0721 8.04401 8.44415 8.26001 8.63615 9.91601H7.07615ZM7.86815 13.12C7.24415 13.12 6.80015 12.676 6.80015 12.052C6.80015 11.428 7.25615 10.996 7.86815 10.996C8.46815 10.996 8.92415 11.428 8.92415 12.052C8.92415 12.676 8.46815 13.12 7.86815 13.12Z",
    fill: "rgba(0, 0, 0, 0.38)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsLight);
export default __webpack_public_path__ + "static/media/tips_light.b58e6a7b80316984ad3432374c024dd3.svg";
export { ForwardRef as ReactComponent };